export default __webpack_public_path__ + "static/media/background.0c5d5146.jpg";